import { createContext } from 'react'

// Scroll della pagina Pick condiviso con i componenti annidati (intestazione fissa della matrice delle cinquine):
//  - subscribe(fn): fn viene chiamata a ogni scroll della pagina
//  - getViewportTop(): coordinata Y (nella finestra) del bordo alto dell'area che scorre
//  - setSticky(node): mostra `node` fissato in alto sopra lo scroll (null per toglierlo)
export const PickScrollContext = createContext({
  subscribe: () => () => {},
  getViewportTop: () => 0,
  setSticky: () => {},
})
